import { z } from 'zod';

export const StudyCategorySchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
  createdAt: z.string().datetime(),
});
export type StudyCategory = z.infer<typeof StudyCategorySchema>;
